import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

function createNotification (notification) {
  const database = firebase.firestore()
  return database.collection('notifications').add(notification)
    .then(res => {
      return res.id
    })
}

export default {
  createNotification
}
